import 'jquery';
import 'es6-promise/auto';
import Turbolinks from 'turbolinks';
import { Navigation } from '../Shared/navigation';

export function initProjectEventForm(ClassicEditor: any, callback: (instance: any) => void = null):any {
	const $form = $('.project-event-form');
	let $textarea = $form.find('#project-event-text');

	ClassicEditor.default.create($textarea.get(0), {
		toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'insertTable', 'undo', 'redo'],
		heading: {
			options: [
				{ model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
				{ model: 'heading5', view: 'h5', title: 'Title', class: 'ck-heading_heading5' },
				{ model: 'heading6', view: 'h6', title: 'Subtitle', class: 'ck-heading_heading6' }
			]
		},
		table: {
			toolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
		}
	}).then((instance: any) => {
		if (callback != null)
			callback(instance);
	});

	$form.find("#status-selector").change(function (e) {
		const $statusTextFormGroup = $form.find("#statustext-form-group");
		const $statusText = $form.find("#project-event-statustext");
		const $reportDate = $form.find("#report-date-selector");

		if ($(this).val() === '') {
			$statusTextFormGroup.fadeOut("slow", function () {
				$statusText.attr("disabled", "disabled");
			});
			$reportDate.attr("disabled", "disabled");
		}
		else {
			$statusText.removeAttr("disabled");
			$statusTextFormGroup.fadeIn("slow");
			$reportDate.removeAttr("disabled");
		}
	});
}

export default function initProjectEventModals(ClassicEditor: any) {
	const $modal = $('.project-event-modal');

	$('.btn-edit-project-event').click(function (e) {
		e.preventDefault();

		const $this = $(this);
		const href = $this.attr('href');
		const title = $this.attr('title');

		$modal.find('.modal-title').text(title);

		// get event form from the server
		$.get(href, function (data) {
			$modal.find('.modal-body').empty().html(data);

			$modal.modal({
				focus: false,
				show: false,
				backdrop: 'static'
			});

			$modal.modal('show');
		});
	});

	let editor: any = null;

	$modal.on('show.bs.modal', function (e) {
		initProjectEventForm(ClassicEditor, function (instance: any) {
			editor = instance;
		});
	});

	$modal.on('shown.bs.modal', function (e) {
		$modal.find('.save-project-event').click(function (e) {
			e.preventDefault();

			const $this = $(this);
			$this.attr('disabled', 'true');

			const $form = $modal.find('.project-event-form');
			if (editor) {
				$form.find('#project-event-text').val(editor.getData());
			}

			$.ajax({
				url: $form.attr('action'),
				type: 'POST',
				data: $form.serialize(),
				success: function (data) {
					$this.attr('disabled', 'false');
					$modal.modal('hide');
					Navigation.reload();
				}
			});
		});
	});

	$modal.on('hidden.bs.modal', function (e) {
		if (editor != null) {
			editor.destroy();
			editor = null;
		}
		$modal.find('.modal-body').empty();
		$modal.find('.save-project-event').off('click');
	});

	$('.delete-project-event-form').on('submit', function (e) {
		e.preventDefault();

		if (confirm('Are you sure?')) {
			var $this = $(this);
			$.ajax({
				url: $this.attr('action'),
				type: "POST",
				data: $(this).serialize(),
				success: function (data) {
					Navigation.reload();
				},
				error: function (jXHR, textStatus, errorThrown) { }
			});
		}
	});
}